import type { PropsWithChildren } from 'react';
import React, { useEffect } from 'react';
import { I18nextProvider } from 'react-i18next';

import { i18nInit } from './i18n';

interface Props {
  lang?: string;
}

export const i18n = i18nInit;

const LanguageContainer: React.FC<PropsWithChildren<Props>> = (props): React.ReactElement => {
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    props.lang && i18nInit.changeLanguage(props.lang);
  }, [props.lang]);

  return <I18nextProvider i18n={i18nInit}>{props.children}</I18nextProvider>;
};

export default LanguageContainer;
